<template>
  <div class="NavBar">
    <div class="NavBar__left">
      <NavBarFiles
      v-if="isActiveTab('files') || isActiveTab('folder')"/>
      <NavBarMedia
      v-if="isActiveTab('media')"/>
      <NavBarSettings
      v-if="isActiveTab('settings')"/>
      <NavBarSearch
      v-if="isActiveTab('search')"/>
    </div>
    <NavBarRight/>
  </div>
</template>

<script>
import NavBarFiles from './files/NavBarFiles'
import NavBarMedia from './media/NavBarMedia'
import NavBarRight from './right/NavBarRight'
import NavBarSearch from './search/NavBarSearch'
import NavBarSettings from './settings/NavBarSettings'

export default {
  name: 'NavBar',

  components: {
    NavBarFiles,
    NavBarMedia,
    NavBarRight,
    NavBarSearch,
    NavBarSettings
  },

  methods: {
    isActiveTab (page) {
      return this.$route.name === page
    }
  }
}
</script>

<style lang="scss">
@import 'NavBar';
</style>
